import * as e from "zod";
//#region src/apiUrls.ts
var t = "https://purchase-order.api.myparcel.nl", n = "https://purchase-order.api.acceptance.myparcel.nl", r = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
//#endregion
//#region src/generated/core/serverSentEvents.gen.ts
var i = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let d, f = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, p = 0, m = u.signal ?? new AbortController().signal;
		for (; !m.aborted;) {
			p++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			d !== void 0 && a.set("Last-Event-ID", d);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: m
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let f = s.body.pipeThrough(new TextDecoderStream()).getReader(), p = "", h = () => {
					try {
						f.cancel();
					} catch {}
				};
				m.addEventListener("abort", h);
				try {
					for (;;) {
						let { done: e, value: t } = await f.read();
						if (e) break;
						p += t, p = p.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
						let a = p.split("\n\n");
						p = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) d = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: d,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					m.removeEventListener("abort", h), f.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && p >= o) break;
				await f(Math.min(c * 2 ** (p - 1), s ?? 3e4));
			}
		}
	}() };
}, a = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, o = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, s = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, c = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(o(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let s = a(r), c = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : l({
		allowReserved: e,
		name: n,
		value: t
	})).join(s);
	return r === "label" || r === "matrix" ? s + c : c;
}, l = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, u = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = s(r), c = Object.entries(i).map(([t, i]) => l({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(o);
	return r === "label" || r === "matrix" ? o + c : c;
}, d = /\{[^{}]+\}/g, f = ({ path: e, url: t }) => {
	let n = t, r = t.match(d);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let o = e[i];
		if (o == null) continue;
		if (Array.isArray(o)) {
			n = n.replace(t, c({
				explode: r,
				name: i,
				style: a,
				value: o
			}));
			continue;
		}
		if (typeof o == "object") {
			n = n.replace(t, u({
				explode: r,
				name: i,
				style: a,
				value: o,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${l({
				name: i,
				value: o
			})}`);
			continue;
		}
		let s = encodeURIComponent(a === "label" ? `.${o}` : o);
		n = n.replace(t, s);
	}
	return n;
}, p = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = f({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function m(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
//#endregion
//#region src/generated/core/auth.gen.ts
var h = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, g = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let o = e[i] || t;
		if (Array.isArray(a)) {
			let e = c({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...o.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = u({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...o.object
			});
			e && r.push(e);
		} else {
			let e = l({
				allowReserved: o.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, ee = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, te = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, ne = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (te(t, n.name)) continue;
		let e = await h(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default:
				t.headers.set(r, e);
				break;
		}
	}
}, _ = (e) => p({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : g(e.querySerializer),
	url: e.url
}), v = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = y(e.headers, t.headers), n;
}, re = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, y = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? re(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, b = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, ie = () => ({
	error: new b(),
	request: new b(),
	response: new b()
}), ae = g({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), oe = { "Content-Type": "application/json" }, x = (e = {}) => ({
	...r,
	headers: oe,
	parseAs: "auto",
	querySerializer: ae,
	...e
}), S = ((e = {}) => {
	let t = v(x(), e), n = () => ({ ...t }), r = (e) => (t = v(t, e), n()), a = ie(), o = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: y(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await ne({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: _(n)
		};
	}, s = async (e) => {
		let { opts: t, url: n } = await o(e), r = {
			redirect: "follow",
			...t,
			body: m(t)
		}, i = new Request(n, r);
		for (let e of a.request.fns) e && (i = await e(i, t));
		let s = t.fetch, c;
		try {
			c = await s(i);
		} catch (e) {
			let n = e;
			for (let r of a.error.fns) r && (n = await r(e, void 0, i, t));
			if (n ||= {}, t.throwOnError) throw n;
			return t.responseStyle === "data" ? void 0 : {
				error: n,
				request: i,
				response: void 0
			};
		}
		for (let e of a.response.fns) e && (c = await e(c, i, t));
		let l = {
			request: i,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? ee(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default:
						n = {};
						break;
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "text":
					n = await c[e]();
					break;
				case "json": {
					let e = await c.text();
					n = e ? JSON.parse(e) : {};
					break;
				}
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), d;
		try {
			d = JSON.parse(u);
		} catch {}
		let f = d ?? u, p = f;
		for (let e of a.error.fns) e && (p = await e(f, c, i, t));
		if (p ||= {}, t.throwOnError) throw p;
		return t.responseStyle === "data" ? void 0 : {
			error: p,
			...l
		};
	}, c = (e) => (t) => s({
		...t,
		method: e
	}), l = (e) => async (t) => {
		let { opts: n, url: r } = await o(t);
		return i({
			...n,
			body: n.body,
			headers: n.headers,
			method: e,
			onRequest: async (e, t) => {
				let r = new Request(e, t);
				for (let e of a.request.fns) e && (r = await e(r, n));
				return r;
			},
			serializedBody: m(n),
			url: r
		});
	};
	return {
		buildUrl: (e) => _({
			...t,
			...e
		}),
		connect: c("CONNECT"),
		delete: c("DELETE"),
		get: c("GET"),
		getConfig: n,
		head: c("HEAD"),
		interceptors: a,
		options: c("OPTIONS"),
		patch: c("PATCH"),
		post: c("POST"),
		put: c("PUT"),
		request: s,
		setConfig: r,
		sse: {
			connect: l("CONNECT"),
			delete: l("DELETE"),
			get: l("GET"),
			head: l("HEAD"),
			options: l("OPTIONS"),
			patch: l("PATCH"),
			post: l("POST"),
			put: l("PUT"),
			trace: l("TRACE")
		},
		trace: c("TRACE")
	};
})(x({
	baseUrl: "https://purchase-order.api.myparcel.nl",
	throwOnError: !0
})), C = e.enum(["VASCO"]).register(e.globalRegistry, { description: "The fulfilment platform." }), w = e.enum(["status"]), T = e.enum(["ASC", "DESC"]).register(e.globalRegistry, { description: "The sort direction." }), E = e.enum([
	"CANCELED",
	"COMPLETED",
	"CONCEPT",
	"PARTIALLY_RECEIVED",
	"REGISTERED",
	"REGISTRATION_REQUESTED"
]).register(e.globalRegistry, { description: "The status of the purchase order." }), D = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
	createdAt: e.iso.datetime().register(e.globalRegistry, { description: "The creation date of the purchase order." }),
	fulfilmentPlatform: e.enum(["VASCO"]).register(e.globalRegistry, { description: "The fulfilment platform." }),
	status: e.enum(["CANCELED"]),
	canceledAt: e.iso.datetime().register(e.globalRegistry, { description: "The cancellation date of the purchase order." }),
	deliverySupplierDetails: e.object({
		supplier: e.string().min(1).max(256).register(e.globalRegistry, { description: "The name of the supplier." }),
		reference: e.string().min(1).max(256).register(e.globalRegistry, { description: "The reference of the supplier." }).optional()
	}).register(e.globalRegistry, { description: "The delivery supplier details of the purchase order." }),
	deliveryType: e.object({
		type: e.enum([
			"CONTAINER",
			"PACKAGE",
			"PALLET"
		]).register(e.globalRegistry, { description: "The type of the expected delivery." }),
		quantity: e.int().gte(1).lte(100).register(e.globalRegistry, { description: "The quantity of the expected delivery type." })
	}).register(e.globalRegistry, { description: "The delivery type of the purchase order." }),
	expectedDelivery: e.object({
		on: e.iso.date().register(e.globalRegistry, { description: "The expected delivery date." }),
		timeslot: e.object({
			from: e.string().register(e.globalRegistry, { description: "The start time of the expected delivery. Must be before `to`." }),
			to: e.string().register(e.globalRegistry, { description: "The end time of the expected delivery. Must be after `from`." })
		}).register(e.globalRegistry, { description: "The timeslot of the expected delivery." })
	}).register(e.globalRegistry, { description: "The expected delivery of the purchase order." }),
	lines: e.array(e.object({
		product: e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			name: e.string().min(1).max(250).register(e.globalRegistry, { description: "The name of the product." }),
			ean: e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." }).optional(),
			sku: e.string().min(1).max(200).register(e.globalRegistry, { description: "The SKU of the product." }).optional()
		}).register(e.globalRegistry, { description: "The product of a line." }),
		quantity: e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "The quantity of the product." })
	}).register(e.globalRegistry, { description: "A line of the purchase order." })).min(1).max(500).register(e.globalRegistry, { description: "The lines of the purchase order." }),
	externalReference: e.string().min(1).max(100).register(e.globalRegistry, { description: "The external reference of the purchase order provided by the fulfilment platform." }).optional()
}), O = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
	createdAt: e.iso.datetime().register(e.globalRegistry, { description: "The creation date of the purchase order." }),
	fulfilmentPlatform: e.enum(["VASCO"]).register(e.globalRegistry, { description: "The fulfilment platform." }),
	status: e.enum(["COMPLETED"]),
	completedAt: e.iso.datetime().register(e.globalRegistry, { description: "The completion date of the purchase order." }),
	deliverySupplierDetails: e.object({
		supplier: e.string().min(1).max(256).register(e.globalRegistry, { description: "The name of the supplier." }),
		reference: e.string().min(1).max(256).register(e.globalRegistry, { description: "The reference of the supplier." }).optional()
	}).register(e.globalRegistry, { description: "The delivery supplier details of the purchase order." }),
	deliveryType: e.object({
		type: e.enum([
			"CONTAINER",
			"PACKAGE",
			"PALLET"
		]).register(e.globalRegistry, { description: "The type of the expected delivery." }),
		quantity: e.int().gte(1).lte(100).register(e.globalRegistry, { description: "The quantity of the expected delivery type." })
	}).register(e.globalRegistry, { description: "The delivery type of the purchase order." }),
	expectedDelivery: e.object({
		on: e.iso.date().register(e.globalRegistry, { description: "The expected delivery date." }),
		timeslot: e.object({
			from: e.string().register(e.globalRegistry, { description: "The start time of the expected delivery. Must be before `to`." }),
			to: e.string().register(e.globalRegistry, { description: "The end time of the expected delivery. Must be after `from`." })
		}).register(e.globalRegistry, { description: "The timeslot of the expected delivery." })
	}).register(e.globalRegistry, { description: "The expected delivery of the purchase order." }),
	externalReference: e.string().min(1).max(100).register(e.globalRegistry, { description: "The external reference of the purchase order provided by the fulfilment platform." }),
	lines: e.array(e.object({
		product: e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			name: e.string().min(1).max(250).register(e.globalRegistry, { description: "The name of the product." }),
			ean: e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." }).optional(),
			sku: e.string().min(1).max(200).register(e.globalRegistry, { description: "The SKU of the product." }).optional()
		}).register(e.globalRegistry, { description: "The product of a line." }),
		quantity: e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "The quantity of the product." })
	}).register(e.globalRegistry, { description: "A line of the purchase order." })).min(1).max(500).register(e.globalRegistry, { description: "The lines of the purchase order." }),
	receipts: e.array(e.object({
		addedAt: e.iso.datetime().register(e.globalRegistry, { description: "The moment when the receipt was added to the purchase order." }),
		product: e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			name: e.string().min(1).max(250).register(e.globalRegistry, { description: "The name of the product." }),
			ean: e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." }).optional(),
			sku: e.string().min(1).max(200).register(e.globalRegistry, { description: "The SKU of the product." }).optional()
		}).register(e.globalRegistry, { description: "The product of a receipt." }),
		quantity: e.union([e.int().gte(-9007199254740991).lt(0), e.int().gt(0).lte(9007199254740991)])
	}).register(e.globalRegistry, { description: "A receipt of the purchase order." })).min(1).max(1e3).register(e.globalRegistry, { description: "The receipts of the purchase order." })
}), k = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
	createdAt: e.iso.datetime().register(e.globalRegistry, { description: "The creation date of the purchase order." }),
	fulfilmentPlatform: e.enum(["VASCO"]).register(e.globalRegistry, { description: "The fulfilment platform." }),
	status: e.enum(["CONCEPT"]),
	deliverySupplierDetails: e.object({
		supplier: e.string().min(1).max(256).register(e.globalRegistry, { description: "The name of the supplier." }),
		reference: e.string().min(1).max(256).register(e.globalRegistry, { description: "The reference of the supplier." }).optional()
	}).register(e.globalRegistry, { description: "The delivery supplier details of the purchase order." }).optional(),
	deliveryType: e.object({
		type: e.enum([
			"CONTAINER",
			"PACKAGE",
			"PALLET"
		]).register(e.globalRegistry, { description: "The type of the expected delivery." }),
		quantity: e.int().gte(1).lte(100).register(e.globalRegistry, { description: "The quantity of the expected delivery type." })
	}).register(e.globalRegistry, { description: "The delivery type of the purchase order." }).optional(),
	expectedDelivery: e.object({
		on: e.iso.date().register(e.globalRegistry, { description: "The expected delivery date." }),
		timeslot: e.object({
			from: e.string().register(e.globalRegistry, { description: "The start time of the expected delivery. Must be before `to`." }),
			to: e.string().register(e.globalRegistry, { description: "The end time of the expected delivery. Must be after `from`." })
		}).register(e.globalRegistry, { description: "The timeslot of the expected delivery." })
	}).register(e.globalRegistry, { description: "The expected delivery of the purchase order." }).optional(),
	lines: e.array(e.object({
		product: e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			name: e.string().min(1).max(250).register(e.globalRegistry, { description: "The name of the product." }),
			ean: e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." }).optional(),
			sku: e.string().min(1).max(200).register(e.globalRegistry, { description: "The SKU of the product." }).optional()
		}).register(e.globalRegistry, { description: "The product of a line." }),
		quantity: e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "The quantity of the product." })
	}).register(e.globalRegistry, { description: "A line of the purchase order." })).min(1).max(500).register(e.globalRegistry, { description: "The lines of the purchase order." }).optional()
}), A = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
	createdAt: e.iso.datetime().register(e.globalRegistry, { description: "The creation date of the purchase order." }),
	fulfilmentPlatform: e.enum(["VASCO"]).register(e.globalRegistry, { description: "The fulfilment platform." }),
	status: e.enum(["PARTIALLY_RECEIVED"]),
	deliverySupplierDetails: e.object({
		supplier: e.string().min(1).max(256).register(e.globalRegistry, { description: "The name of the supplier." }),
		reference: e.string().min(1).max(256).register(e.globalRegistry, { description: "The reference of the supplier." }).optional()
	}).register(e.globalRegistry, { description: "The delivery supplier details of the purchase order." }),
	deliveryType: e.object({
		type: e.enum([
			"CONTAINER",
			"PACKAGE",
			"PALLET"
		]).register(e.globalRegistry, { description: "The type of the expected delivery." }),
		quantity: e.int().gte(1).lte(100).register(e.globalRegistry, { description: "The quantity of the expected delivery type." })
	}).register(e.globalRegistry, { description: "The delivery type of the purchase order." }),
	expectedDelivery: e.object({
		on: e.iso.date().register(e.globalRegistry, { description: "The expected delivery date." }),
		timeslot: e.object({
			from: e.string().register(e.globalRegistry, { description: "The start time of the expected delivery. Must be before `to`." }),
			to: e.string().register(e.globalRegistry, { description: "The end time of the expected delivery. Must be after `from`." })
		}).register(e.globalRegistry, { description: "The timeslot of the expected delivery." })
	}).register(e.globalRegistry, { description: "The expected delivery of the purchase order." }),
	externalReference: e.string().min(1).max(100).register(e.globalRegistry, { description: "The external reference of the purchase order provided by the fulfilment platform." }),
	lines: e.array(e.object({
		product: e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			name: e.string().min(1).max(250).register(e.globalRegistry, { description: "The name of the product." }),
			ean: e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." }).optional(),
			sku: e.string().min(1).max(200).register(e.globalRegistry, { description: "The SKU of the product." }).optional()
		}).register(e.globalRegistry, { description: "The product of a line." }),
		quantity: e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "The quantity of the product." })
	}).register(e.globalRegistry, { description: "A line of the purchase order." })).min(1).max(500).register(e.globalRegistry, { description: "The lines of the purchase order." }),
	receipts: e.array(e.object({
		addedAt: e.iso.datetime().register(e.globalRegistry, { description: "The moment when the receipt was added to the purchase order." }),
		product: e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			name: e.string().min(1).max(250).register(e.globalRegistry, { description: "The name of the product." }),
			ean: e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." }).optional(),
			sku: e.string().min(1).max(200).register(e.globalRegistry, { description: "The SKU of the product." }).optional()
		}).register(e.globalRegistry, { description: "The product of a receipt." }),
		quantity: e.union([e.int().gte(-9007199254740991).lt(0), e.int().gt(0).lte(9007199254740991)])
	}).register(e.globalRegistry, { description: "A receipt of the purchase order." })).min(1).max(1e3).register(e.globalRegistry, { description: "The receipts of the purchase order." })
}), j = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
	createdAt: e.iso.datetime().register(e.globalRegistry, { description: "The creation date of the purchase order." }),
	fulfilmentPlatform: e.enum(["VASCO"]).register(e.globalRegistry, { description: "The fulfilment platform." }),
	status: e.enum(["REGISTERED"]),
	deliverySupplierDetails: e.object({
		supplier: e.string().min(1).max(256).register(e.globalRegistry, { description: "The name of the supplier." }),
		reference: e.string().min(1).max(256).register(e.globalRegistry, { description: "The reference of the supplier." }).optional()
	}).register(e.globalRegistry, { description: "The delivery supplier details of the purchase order." }),
	deliveryType: e.object({
		type: e.enum([
			"CONTAINER",
			"PACKAGE",
			"PALLET"
		]).register(e.globalRegistry, { description: "The type of the expected delivery." }),
		quantity: e.int().gte(1).lte(100).register(e.globalRegistry, { description: "The quantity of the expected delivery type." })
	}).register(e.globalRegistry, { description: "The delivery type of the purchase order." }),
	expectedDelivery: e.object({
		on: e.iso.date().register(e.globalRegistry, { description: "The expected delivery date." }),
		timeslot: e.object({
			from: e.string().register(e.globalRegistry, { description: "The start time of the expected delivery. Must be before `to`." }),
			to: e.string().register(e.globalRegistry, { description: "The end time of the expected delivery. Must be after `from`." })
		}).register(e.globalRegistry, { description: "The timeslot of the expected delivery." })
	}).register(e.globalRegistry, { description: "The expected delivery of the purchase order." }),
	externalReference: e.string().min(1).max(100).register(e.globalRegistry, { description: "The external reference of the purchase order provided by the fulfilment platform." }),
	lines: e.array(e.object({
		product: e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			name: e.string().min(1).max(250).register(e.globalRegistry, { description: "The name of the product." }),
			ean: e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." }).optional(),
			sku: e.string().min(1).max(200).register(e.globalRegistry, { description: "The SKU of the product." }).optional()
		}).register(e.globalRegistry, { description: "The product of a line." }),
		quantity: e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "The quantity of the product." })
	}).register(e.globalRegistry, { description: "A line of the purchase order." })).min(1).max(500).register(e.globalRegistry, { description: "The lines of the purchase order." })
}), M = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
	createdAt: e.iso.datetime().register(e.globalRegistry, { description: "The creation date of the purchase order." }),
	fulfilmentPlatform: e.enum(["VASCO"]).register(e.globalRegistry, { description: "The fulfilment platform." }),
	status: e.enum(["REGISTRATION_REQUESTED"]),
	deliverySupplierDetails: e.object({
		supplier: e.string().min(1).max(256).register(e.globalRegistry, { description: "The name of the supplier." }),
		reference: e.string().min(1).max(256).register(e.globalRegistry, { description: "The reference of the supplier." }).optional()
	}).register(e.globalRegistry, { description: "The delivery supplier details of the purchase order." }),
	deliveryType: e.object({
		type: e.enum([
			"CONTAINER",
			"PACKAGE",
			"PALLET"
		]).register(e.globalRegistry, { description: "The type of the expected delivery." }),
		quantity: e.int().gte(1).lte(100).register(e.globalRegistry, { description: "The quantity of the expected delivery type." })
	}).register(e.globalRegistry, { description: "The delivery type of the purchase order." }),
	expectedDelivery: e.object({
		on: e.iso.date().register(e.globalRegistry, { description: "The expected delivery date." }),
		timeslot: e.object({
			from: e.string().register(e.globalRegistry, { description: "The start time of the expected delivery. Must be before `to`." }),
			to: e.string().register(e.globalRegistry, { description: "The end time of the expected delivery. Must be after `from`." })
		}).register(e.globalRegistry, { description: "The timeslot of the expected delivery." })
	}).register(e.globalRegistry, { description: "The expected delivery of the purchase order." }),
	lines: e.array(e.object({
		product: e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			name: e.string().min(1).max(250).register(e.globalRegistry, { description: "The name of the product." }),
			ean: e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." }).optional(),
			sku: e.string().min(1).max(200).register(e.globalRegistry, { description: "The SKU of the product." }).optional()
		}).register(e.globalRegistry, { description: "The product of a line." }),
		quantity: e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "The quantity of the product." })
	}).register(e.globalRegistry, { description: "A line of the purchase order." })).min(1).max(500).register(e.globalRegistry, { description: "The lines of the purchase order." })
}), N = e.union([
	e.object({ status: e.literal("CANCELED") }).and(D),
	e.object({ status: e.literal("COMPLETED") }).and(O),
	e.object({ status: e.literal("CONCEPT") }).and(k),
	e.object({ status: e.literal("PARTIALLY_RECEIVED") }).and(A),
	e.object({ status: e.literal("REGISTERED") }).and(j),
	e.object({ status: e.literal("REGISTRATION_REQUESTED") }).and(M)
]), P = e.object({
	type: e.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: e.union([
		e.literal(400),
		e.literal(401),
		e.literal(404),
		e.literal(415),
		e.literal(500)
	]).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: e.string().min(1).max(100).register(e.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: e.string().min(1).max(5e3).register(e.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: e.url().register(e.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: e.unknown().register(e.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}), se = P.and(e.object({
	type: e.enum(["urn:problem:invalid-request-syntax"]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(400).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: e.array(e.object({
		detail: e.string().min(1).max(5e3),
		pointer: e.string().min(1).max(200).register(e.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).min(1).register(e.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), ce = P.and(e.object({
	type: e.enum(["urn:problem:not-found"]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(404).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional()
})), F = e.object({
	body: e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
		lines: e.array(e.object({
			productId: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			quantity: e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "The quantity of the product." })
		}).register(e.globalRegistry, { description: "A line to add to the purchase order." })).min(1).max(500).register(e.globalRegistry, { description: "The lines to add to the purchase order." })
	}).register(e.globalRegistry, { description: "Body for adding lines to a purchase order." }),
	path: e.never().optional(),
	query: e.never().optional()
}), le = e.union([
	e.object({ status: e.literal("CONCEPT") }).and(k),
	e.object({ status: e.literal("REGISTERED") }).and(j),
	e.object({ status: e.literal("REGISTRATION_REQUESTED") }).and(M)
]), I = e.object({
	body: e.object({ ids: e.array(e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." })).min(1).max(50) }).register(e.globalRegistry, { description: "Body for canceling purchase orders." }),
	path: e.never().optional(),
	query: e.never().optional()
}), ue = e.void().register(e.globalRegistry, { description: "Purchase orders are cancelled." }), L = e.object({
	body: e.object({
		fulfilmentPlatform: C,
		lines: e.array(e.object({
			productId: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			quantity: e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "The quantity of the product." })
		}).register(e.globalRegistry, { description: "A line of the purchase order." })).min(1).max(500).register(e.globalRegistry, { description: "The lines of the purchase order." }),
		deliverySupplierDetails: e.object({
			supplier: e.string().min(1).max(256).register(e.globalRegistry, { description: "The name of the supplier." }),
			reference: e.string().min(1).max(256).register(e.globalRegistry, { description: "The reference of the supplier." }).optional()
		}).register(e.globalRegistry, { description: "The delivery supplier details of the purchase order." }).optional(),
		deliveryType: e.object({
			type: e.enum([
				"CONTAINER",
				"PACKAGE",
				"PALLET"
			]).register(e.globalRegistry, { description: "The type of the expected delivery." }),
			quantity: e.int().gte(1).lte(100).register(e.globalRegistry, { description: "The quantity of the expected delivery type." })
		}).register(e.globalRegistry, { description: "The delivery type of the purchase order." }).optional(),
		expectedDelivery: e.object({
			on: e.iso.date().register(e.globalRegistry, { description: "The expected delivery date. Must be later than today." }),
			timeslot: e.object({
				from: e.string().register(e.globalRegistry, { description: "The start time of the expected delivery. Must be before `to`." }),
				to: e.string().register(e.globalRegistry, { description: "The end time of the expected delivery. Must be after `from`." })
			}).register(e.globalRegistry, { description: "The timeslot of the expected delivery." })
		}).register(e.globalRegistry, { description: "The expected delivery of the purchase order." }).optional()
	}).register(e.globalRegistry, { description: "Body for creating a purchase order." }),
	path: e.never().optional(),
	query: e.never().optional()
}), de = k, R = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		aggregation: e.tuple([w]).register(e.globalRegistry, { description: "Fields to summarize data for based on the filters and query." }).optional(),
		filter: e.object({
			fulfilmentPlatform: e.tuple([C]).optional(),
			purchaseOrderId: e.array(e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." })).min(1).max(100).optional(),
			status: e.array(E).min(1).max(6).optional()
		}).optional(),
		limit: e.int().gte(1).lte(50).register(e.globalRegistry, { description: "The maximum number of purchase orders to retrieve." }).optional().default(50),
		pageToken: e.string().min(4).max(500).register(e.globalRegistry, { description: "The page token to retrieve the next page of purchase orders." }).optional(),
		query: e.string().min(1).max(500).register(e.globalRegistry, { description: "The following operators are supported:\n'+ signifies AND operation'\n'| signifies OR operation'\n'- negates a single token'\n'\" wraps a number of tokens to signify a phrase for searching'\n'* at the end of a term signifies a prefix query'\n'( and ) signify precedence'\n'~N after a word signifies edit distance (fuzziness)'\n'~N after a phrase signifies slop amount'\nTo use one of these characters literally, escape it with a preceding backslash (\\)." }).optional(),
		sort: e.object({
			createdAt: T.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the `createdAt` property." })).optional(),
			deliveryQuantity: T.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the `deliveryType.quantity` property." })).optional(),
			deliverySupplierReference: T.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the `deliverySupplierDetails.reference` property." })).optional(),
			deliveryType: T.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the `deliveryType.type` property." })).optional(),
			expectedDelivery: T.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the `expectedDelivery.on` property." })).optional(),
			externalReference: T.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the `externalReference` property." })).optional(),
			status: T.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the `status` property." })).optional()
		}).register(e.globalRegistry, { description: "When no `query` is provided the default sort is by `createdAt` descending. When a `query` is provided the default sort is by relevance." }).optional()
	}).optional()
}), fe = e.object({
	results: e.array(N).min(0).max(50).register(e.globalRegistry, { description: "The list of purchase orders." }),
	total: e.object({
		relation: e.enum(["eq", "gte"]).register(e.globalRegistry, { description: "The relation of the total number of purchase orders." }),
		value: e.int().gte(0).register(e.globalRegistry, { description: "The total number of purchase orders." })
	}),
	aggregations: e.object({ status: e.array(e.object({
		key: e.enum([
			"CANCELED",
			"COMPLETED",
			"CONCEPT",
			"PARTIALLY_RECEIVED",
			"REGISTERED",
			"REGISTRATION_REQUESTED"
		]).register(e.globalRegistry, { description: "The status of the purchase order." }),
		count: e.int().gte(0)
	})).optional() }).register(e.globalRegistry, { description: "The requested aggregations of the purchase orders." }).optional(),
	nextPageToken: e.string().min(1).max(500).register(e.globalRegistry, { description: "The next page token to retrieve the next page of purchase orders." }).optional()
}).register(e.globalRegistry, { description: "The listed purchase orders." }), z = e.object({
	body: e.never().optional(),
	path: e.object({ purchaseOrderId: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }) }),
	query: e.object({
		firstName: e.string().min(1).max(100).register(e.globalRegistry, { description: "First name on the packing slip." }).optional(),
		lastName: e.string().min(1).max(100).register(e.globalRegistry, { description: "Last name on the packing slip." }).optional()
	}).optional(),
	headers: e.object({ Accept: e.enum(["application/pdf"]) })
}), pe = e.string().register(e.globalRegistry, { description: "The packing slip PDF." }), B = e.object({
	body: e.object({ ids: e.array(e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." })).min(1).max(50) }).register(e.globalRegistry, { description: "Body for removing a purchase order ." }),
	path: e.never().optional(),
	query: e.never().optional()
}), me = e.void().register(e.globalRegistry, { description: "Purchase order is removed." }), V = e.object({
	body: e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
		productIds: e.array(e.uuid().register(e.globalRegistry, { description: "The ID of the product." })).min(1).max(500).register(e.globalRegistry, { description: "The product IDs to remove from the purchase order." })
	}).register(e.globalRegistry, { description: "Body for removing lines of a purchase order." }),
	path: e.never().optional(),
	query: e.never().optional()
}), he = e.union([
	e.object({ status: e.literal("CONCEPT") }).and(k),
	e.object({ status: e.literal("REGISTERED") }).and(j),
	e.object({ status: e.literal("REGISTRATION_REQUESTED") }).and(M)
]), H = e.object({
	body: e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
		supplier: e.string().min(1).max(256).register(e.globalRegistry, { description: "The name of the supplier." }),
		reference: e.string().min(1).max(256).register(e.globalRegistry, { description: "The reference of the supplier." }).optional()
	}).register(e.globalRegistry, { description: "Body for setting the delivery supplier details for a purchase order." }),
	path: e.never().optional(),
	query: e.never().optional()
}), ge = e.union([
	e.object({ status: e.literal("CONCEPT") }).and(k),
	e.object({ status: e.literal("REGISTERED") }).and(j),
	e.object({ status: e.literal("REGISTRATION_REQUESTED") }).and(M)
]), U = e.object({
	body: e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
		type: e.enum([
			"CONTAINER",
			"PACKAGE",
			"PALLET"
		]).register(e.globalRegistry, { description: "The type of the expected delivery." }),
		quantity: e.int().gte(1).lte(100).register(e.globalRegistry, { description: "The quantity of the expected delivery type." })
	}).register(e.globalRegistry, { description: "Body for setting the delivery type of a purchase order." }),
	path: e.never().optional(),
	query: e.never().optional()
}), _e = e.union([
	e.object({ status: e.literal("CONCEPT") }).and(k),
	e.object({ status: e.literal("REGISTERED") }).and(j),
	e.object({ status: e.literal("REGISTRATION_REQUESTED") }).and(M)
]), W = e.object({
	body: e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
		on: e.iso.date().register(e.globalRegistry, { description: "The expected delivery date. Must be later than today." }),
		timeslot: e.object({
			from: e.string().register(e.globalRegistry, { description: "The start time of the expected delivery. Must be before `to`." }),
			to: e.string().register(e.globalRegistry, { description: "The end time of the expected delivery. Must be after `from`." })
		}).register(e.globalRegistry, { description: "The timeslot of the expected delivery." })
	}).register(e.globalRegistry, { description: "Body for setting the expected delivery of a purchase order." }),
	path: e.never().optional(),
	query: e.never().optional()
}), ve = e.union([
	e.object({ status: e.literal("CONCEPT") }).and(k),
	e.object({ status: e.literal("REGISTERED") }).and(j),
	e.object({ status: e.literal("REGISTRATION_REQUESTED") }).and(M)
]), G = e.object({
	body: e.object({ ids: e.array(e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." })).min(1).max(50) }).register(e.globalRegistry, { description: "Body for registering purchase orders." }),
	path: e.never().optional(),
	query: e.never().optional()
}), ye = e.void().register(e.globalRegistry, { description: "Purchase orders are requested to register." }), K = e.object({
	body: e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
		productId: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
		quantity: e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "The quantity of the product." })
	}).register(e.globalRegistry, { description: "Body for updating the quantity of a purchase order line." }),
	path: e.never().optional(),
	query: e.never().optional()
}), be = e.union([
	e.object({ status: e.literal("CONCEPT") }).and(k),
	e.object({ status: e.literal("REGISTERED") }).and(j),
	e.object({ status: e.literal("REGISTRATION_REQUESTED") }).and(M)
]), q = e.union([e.enum(["VASCO"]), e.string()]).register(e.globalRegistry, { description: "The fulfilment platform." }), xe = e.union([e.enum(["status"]), e.string()]), J = e.union([e.enum(["ASC", "DESC"]), e.string()]).register(e.globalRegistry, { description: "The sort direction." }), Se = e.union([e.enum([
	"CANCELED",
	"COMPLETED",
	"CONCEPT",
	"PARTIALLY_RECEIVED",
	"REGISTERED",
	"REGISTRATION_REQUESTED"
]), e.string()]).register(e.globalRegistry, { description: "The status of the purchase order." }), Ce = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
	createdAt: e.iso.datetime().register(e.globalRegistry, { description: "The creation date of the purchase order." }),
	fulfilmentPlatform: e.union([e.enum(["VASCO"]), e.string()]).register(e.globalRegistry, { description: "The fulfilment platform." }),
	status: e.union([e.enum(["CANCELED"]), e.string()]),
	canceledAt: e.iso.datetime().register(e.globalRegistry, { description: "The cancellation date of the purchase order." }),
	deliverySupplierDetails: e.object({
		supplier: e.string().register(e.globalRegistry, { description: "The name of the supplier." }),
		reference: e.string().register(e.globalRegistry, { description: "The reference of the supplier." }).optional()
	}).register(e.globalRegistry, { description: "The delivery supplier details of the purchase order." }),
	deliveryType: e.object({
		type: e.union([e.enum([
			"CONTAINER",
			"PACKAGE",
			"PALLET"
		]), e.string()]).register(e.globalRegistry, { description: "The type of the expected delivery." }),
		quantity: e.int().gte(1).lte(100).register(e.globalRegistry, { description: "The quantity of the expected delivery type." })
	}).register(e.globalRegistry, { description: "The delivery type of the purchase order." }),
	expectedDelivery: e.object({
		on: e.iso.date().register(e.globalRegistry, { description: "The expected delivery date." }),
		timeslot: e.object({
			from: e.string().register(e.globalRegistry, { description: "The start time of the expected delivery. Must be before `to`." }),
			to: e.string().register(e.globalRegistry, { description: "The end time of the expected delivery. Must be after `from`." })
		}).register(e.globalRegistry, { description: "The timeslot of the expected delivery." })
	}).register(e.globalRegistry, { description: "The expected delivery of the purchase order." }),
	lines: e.array(e.object({
		product: e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			name: e.string().register(e.globalRegistry, { description: "The name of the product." }),
			ean: e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." }).optional(),
			sku: e.string().register(e.globalRegistry, { description: "The SKU of the product." }).optional()
		}).register(e.globalRegistry, { description: "The product of a line." }),
		quantity: e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "The quantity of the product." })
	}).register(e.globalRegistry, { description: "A line of the purchase order." })).register(e.globalRegistry, { description: "The lines of the purchase order." }),
	externalReference: e.string().register(e.globalRegistry, { description: "The external reference of the purchase order provided by the fulfilment platform." }).optional()
}), we = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
	createdAt: e.iso.datetime().register(e.globalRegistry, { description: "The creation date of the purchase order." }),
	fulfilmentPlatform: e.union([e.enum(["VASCO"]), e.string()]).register(e.globalRegistry, { description: "The fulfilment platform." }),
	status: e.union([e.enum(["COMPLETED"]), e.string()]),
	completedAt: e.iso.datetime().register(e.globalRegistry, { description: "The completion date of the purchase order." }),
	deliverySupplierDetails: e.object({
		supplier: e.string().register(e.globalRegistry, { description: "The name of the supplier." }),
		reference: e.string().register(e.globalRegistry, { description: "The reference of the supplier." }).optional()
	}).register(e.globalRegistry, { description: "The delivery supplier details of the purchase order." }),
	deliveryType: e.object({
		type: e.union([e.enum([
			"CONTAINER",
			"PACKAGE",
			"PALLET"
		]), e.string()]).register(e.globalRegistry, { description: "The type of the expected delivery." }),
		quantity: e.int().gte(1).lte(100).register(e.globalRegistry, { description: "The quantity of the expected delivery type." })
	}).register(e.globalRegistry, { description: "The delivery type of the purchase order." }),
	expectedDelivery: e.object({
		on: e.iso.date().register(e.globalRegistry, { description: "The expected delivery date." }),
		timeslot: e.object({
			from: e.string().register(e.globalRegistry, { description: "The start time of the expected delivery. Must be before `to`." }),
			to: e.string().register(e.globalRegistry, { description: "The end time of the expected delivery. Must be after `from`." })
		}).register(e.globalRegistry, { description: "The timeslot of the expected delivery." })
	}).register(e.globalRegistry, { description: "The expected delivery of the purchase order." }),
	externalReference: e.string().register(e.globalRegistry, { description: "The external reference of the purchase order provided by the fulfilment platform." }),
	lines: e.array(e.object({
		product: e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			name: e.string().register(e.globalRegistry, { description: "The name of the product." }),
			ean: e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." }).optional(),
			sku: e.string().register(e.globalRegistry, { description: "The SKU of the product." }).optional()
		}).register(e.globalRegistry, { description: "The product of a line." }),
		quantity: e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "The quantity of the product." })
	}).register(e.globalRegistry, { description: "A line of the purchase order." })).register(e.globalRegistry, { description: "The lines of the purchase order." }),
	receipts: e.array(e.object({
		addedAt: e.iso.datetime().register(e.globalRegistry, { description: "The moment when the receipt was added to the purchase order." }),
		product: e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			name: e.string().register(e.globalRegistry, { description: "The name of the product." }),
			ean: e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." }).optional(),
			sku: e.string().register(e.globalRegistry, { description: "The SKU of the product." }).optional()
		}).register(e.globalRegistry, { description: "The product of a receipt." }),
		quantity: e.union([e.int().gte(-9007199254740991).lt(0), e.int().gt(0).lte(9007199254740991)])
	}).register(e.globalRegistry, { description: "A receipt of the purchase order." })).register(e.globalRegistry, { description: "The receipts of the purchase order." })
}), Y = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
	createdAt: e.iso.datetime().register(e.globalRegistry, { description: "The creation date of the purchase order." }),
	fulfilmentPlatform: e.union([e.enum(["VASCO"]), e.string()]).register(e.globalRegistry, { description: "The fulfilment platform." }),
	status: e.union([e.enum(["CONCEPT"]), e.string()]),
	deliverySupplierDetails: e.object({
		supplier: e.string().register(e.globalRegistry, { description: "The name of the supplier." }),
		reference: e.string().register(e.globalRegistry, { description: "The reference of the supplier." }).optional()
	}).register(e.globalRegistry, { description: "The delivery supplier details of the purchase order." }).optional(),
	deliveryType: e.object({
		type: e.union([e.enum([
			"CONTAINER",
			"PACKAGE",
			"PALLET"
		]), e.string()]).register(e.globalRegistry, { description: "The type of the expected delivery." }),
		quantity: e.int().gte(1).lte(100).register(e.globalRegistry, { description: "The quantity of the expected delivery type." })
	}).register(e.globalRegistry, { description: "The delivery type of the purchase order." }).optional(),
	expectedDelivery: e.object({
		on: e.iso.date().register(e.globalRegistry, { description: "The expected delivery date." }),
		timeslot: e.object({
			from: e.string().register(e.globalRegistry, { description: "The start time of the expected delivery. Must be before `to`." }),
			to: e.string().register(e.globalRegistry, { description: "The end time of the expected delivery. Must be after `from`." })
		}).register(e.globalRegistry, { description: "The timeslot of the expected delivery." })
	}).register(e.globalRegistry, { description: "The expected delivery of the purchase order." }).optional(),
	lines: e.array(e.object({
		product: e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			name: e.string().register(e.globalRegistry, { description: "The name of the product." }),
			ean: e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." }).optional(),
			sku: e.string().register(e.globalRegistry, { description: "The SKU of the product." }).optional()
		}).register(e.globalRegistry, { description: "The product of a line." }),
		quantity: e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "The quantity of the product." })
	}).register(e.globalRegistry, { description: "A line of the purchase order." })).register(e.globalRegistry, { description: "The lines of the purchase order." }).optional()
}), Te = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
	createdAt: e.iso.datetime().register(e.globalRegistry, { description: "The creation date of the purchase order." }),
	fulfilmentPlatform: e.union([e.enum(["VASCO"]), e.string()]).register(e.globalRegistry, { description: "The fulfilment platform." }),
	status: e.union([e.enum(["PARTIALLY_RECEIVED"]), e.string()]),
	deliverySupplierDetails: e.object({
		supplier: e.string().register(e.globalRegistry, { description: "The name of the supplier." }),
		reference: e.string().register(e.globalRegistry, { description: "The reference of the supplier." }).optional()
	}).register(e.globalRegistry, { description: "The delivery supplier details of the purchase order." }),
	deliveryType: e.object({
		type: e.union([e.enum([
			"CONTAINER",
			"PACKAGE",
			"PALLET"
		]), e.string()]).register(e.globalRegistry, { description: "The type of the expected delivery." }),
		quantity: e.int().gte(1).lte(100).register(e.globalRegistry, { description: "The quantity of the expected delivery type." })
	}).register(e.globalRegistry, { description: "The delivery type of the purchase order." }),
	expectedDelivery: e.object({
		on: e.iso.date().register(e.globalRegistry, { description: "The expected delivery date." }),
		timeslot: e.object({
			from: e.string().register(e.globalRegistry, { description: "The start time of the expected delivery. Must be before `to`." }),
			to: e.string().register(e.globalRegistry, { description: "The end time of the expected delivery. Must be after `from`." })
		}).register(e.globalRegistry, { description: "The timeslot of the expected delivery." })
	}).register(e.globalRegistry, { description: "The expected delivery of the purchase order." }),
	externalReference: e.string().register(e.globalRegistry, { description: "The external reference of the purchase order provided by the fulfilment platform." }),
	lines: e.array(e.object({
		product: e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			name: e.string().register(e.globalRegistry, { description: "The name of the product." }),
			ean: e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." }).optional(),
			sku: e.string().register(e.globalRegistry, { description: "The SKU of the product." }).optional()
		}).register(e.globalRegistry, { description: "The product of a line." }),
		quantity: e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "The quantity of the product." })
	}).register(e.globalRegistry, { description: "A line of the purchase order." })).register(e.globalRegistry, { description: "The lines of the purchase order." }),
	receipts: e.array(e.object({
		addedAt: e.iso.datetime().register(e.globalRegistry, { description: "The moment when the receipt was added to the purchase order." }),
		product: e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			name: e.string().register(e.globalRegistry, { description: "The name of the product." }),
			ean: e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." }).optional(),
			sku: e.string().register(e.globalRegistry, { description: "The SKU of the product." }).optional()
		}).register(e.globalRegistry, { description: "The product of a receipt." }),
		quantity: e.union([e.int().gte(-9007199254740991).lt(0), e.int().gt(0).lte(9007199254740991)])
	}).register(e.globalRegistry, { description: "A receipt of the purchase order." })).register(e.globalRegistry, { description: "The receipts of the purchase order." })
}), X = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
	createdAt: e.iso.datetime().register(e.globalRegistry, { description: "The creation date of the purchase order." }),
	fulfilmentPlatform: e.union([e.enum(["VASCO"]), e.string()]).register(e.globalRegistry, { description: "The fulfilment platform." }),
	status: e.union([e.enum(["REGISTERED"]), e.string()]),
	deliverySupplierDetails: e.object({
		supplier: e.string().register(e.globalRegistry, { description: "The name of the supplier." }),
		reference: e.string().register(e.globalRegistry, { description: "The reference of the supplier." }).optional()
	}).register(e.globalRegistry, { description: "The delivery supplier details of the purchase order." }),
	deliveryType: e.object({
		type: e.union([e.enum([
			"CONTAINER",
			"PACKAGE",
			"PALLET"
		]), e.string()]).register(e.globalRegistry, { description: "The type of the expected delivery." }),
		quantity: e.int().gte(1).lte(100).register(e.globalRegistry, { description: "The quantity of the expected delivery type." })
	}).register(e.globalRegistry, { description: "The delivery type of the purchase order." }),
	expectedDelivery: e.object({
		on: e.iso.date().register(e.globalRegistry, { description: "The expected delivery date." }),
		timeslot: e.object({
			from: e.string().register(e.globalRegistry, { description: "The start time of the expected delivery. Must be before `to`." }),
			to: e.string().register(e.globalRegistry, { description: "The end time of the expected delivery. Must be after `from`." })
		}).register(e.globalRegistry, { description: "The timeslot of the expected delivery." })
	}).register(e.globalRegistry, { description: "The expected delivery of the purchase order." }),
	externalReference: e.string().register(e.globalRegistry, { description: "The external reference of the purchase order provided by the fulfilment platform." }),
	lines: e.array(e.object({
		product: e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			name: e.string().register(e.globalRegistry, { description: "The name of the product." }),
			ean: e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." }).optional(),
			sku: e.string().register(e.globalRegistry, { description: "The SKU of the product." }).optional()
		}).register(e.globalRegistry, { description: "The product of a line." }),
		quantity: e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "The quantity of the product." })
	}).register(e.globalRegistry, { description: "A line of the purchase order." })).register(e.globalRegistry, { description: "The lines of the purchase order." })
}), Z = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
	createdAt: e.iso.datetime().register(e.globalRegistry, { description: "The creation date of the purchase order." }),
	fulfilmentPlatform: e.union([e.enum(["VASCO"]), e.string()]).register(e.globalRegistry, { description: "The fulfilment platform." }),
	status: e.union([e.enum(["REGISTRATION_REQUESTED"]), e.string()]),
	deliverySupplierDetails: e.object({
		supplier: e.string().register(e.globalRegistry, { description: "The name of the supplier." }),
		reference: e.string().register(e.globalRegistry, { description: "The reference of the supplier." }).optional()
	}).register(e.globalRegistry, { description: "The delivery supplier details of the purchase order." }),
	deliveryType: e.object({
		type: e.union([e.enum([
			"CONTAINER",
			"PACKAGE",
			"PALLET"
		]), e.string()]).register(e.globalRegistry, { description: "The type of the expected delivery." }),
		quantity: e.int().gte(1).lte(100).register(e.globalRegistry, { description: "The quantity of the expected delivery type." })
	}).register(e.globalRegistry, { description: "The delivery type of the purchase order." }),
	expectedDelivery: e.object({
		on: e.iso.date().register(e.globalRegistry, { description: "The expected delivery date." }),
		timeslot: e.object({
			from: e.string().register(e.globalRegistry, { description: "The start time of the expected delivery. Must be before `to`." }),
			to: e.string().register(e.globalRegistry, { description: "The end time of the expected delivery. Must be after `from`." })
		}).register(e.globalRegistry, { description: "The timeslot of the expected delivery." })
	}).register(e.globalRegistry, { description: "The expected delivery of the purchase order." }),
	lines: e.array(e.object({
		product: e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			name: e.string().register(e.globalRegistry, { description: "The name of the product." }),
			ean: e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." }).optional(),
			sku: e.string().register(e.globalRegistry, { description: "The SKU of the product." }).optional()
		}).register(e.globalRegistry, { description: "The product of a line." }),
		quantity: e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "The quantity of the product." })
	}).register(e.globalRegistry, { description: "A line of the purchase order." })).register(e.globalRegistry, { description: "The lines of the purchase order." })
}), Ee = e.union([
	e.object({ status: e.literal("CANCELED") }).and(Ce),
	e.object({ status: e.literal("COMPLETED") }).and(we),
	e.object({ status: e.literal("CONCEPT") }).and(Y),
	e.object({ status: e.literal("PARTIALLY_RECEIVED") }).and(Te),
	e.object({ status: e.literal("REGISTERED") }).and(X),
	e.object({ status: e.literal("REGISTRATION_REQUESTED") }).and(Z)
]), Q = e.object({
	type: e.union([e.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: e.union([
		e.literal(400),
		e.literal(401),
		e.literal(404),
		e.literal(415),
		e.literal(500)
	]).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: e.string().register(e.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: e.string().register(e.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: e.url().register(e.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: e.unknown().register(e.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
});
Q.and(e.object({
	type: e.union([e.enum(["urn:problem:invalid-request-syntax"]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(400).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: e.array(e.object({
		detail: e.string(),
		pointer: e.string().register(e.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).register(e.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), Q.and(e.object({
	type: e.union([e.enum(["urn:problem:not-found"]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(404).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional()
})), e.object({
	body: e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
		lines: e.array(e.object({
			productId: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			quantity: e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "The quantity of the product." })
		}).register(e.globalRegistry, { description: "A line to add to the purchase order." })).register(e.globalRegistry, { description: "The lines to add to the purchase order." })
	}).register(e.globalRegistry, { description: "Body for adding lines to a purchase order." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var De = e.union([
	e.object({ status: e.literal("CONCEPT") }).and(Y),
	e.object({ status: e.literal("REGISTERED") }).and(X),
	e.object({ status: e.literal("REGISTRATION_REQUESTED") }).and(Z)
]);
e.object({
	body: e.object({ ids: e.array(e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." })) }).register(e.globalRegistry, { description: "Body for canceling purchase orders." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Oe = e.void().register(e.globalRegistry, { description: "Purchase orders are cancelled." });
e.object({
	body: e.object({
		fulfilmentPlatform: q,
		lines: e.array(e.object({
			productId: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			quantity: e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "The quantity of the product." })
		}).register(e.globalRegistry, { description: "A line of the purchase order." })).register(e.globalRegistry, { description: "The lines of the purchase order." }),
		deliverySupplierDetails: e.object({
			supplier: e.string().register(e.globalRegistry, { description: "The name of the supplier." }),
			reference: e.string().register(e.globalRegistry, { description: "The reference of the supplier." }).optional()
		}).register(e.globalRegistry, { description: "The delivery supplier details of the purchase order." }).optional(),
		deliveryType: e.object({
			type: e.union([e.enum([
				"CONTAINER",
				"PACKAGE",
				"PALLET"
			]), e.string()]).register(e.globalRegistry, { description: "The type of the expected delivery." }),
			quantity: e.int().gte(1).lte(100).register(e.globalRegistry, { description: "The quantity of the expected delivery type." })
		}).register(e.globalRegistry, { description: "The delivery type of the purchase order." }).optional(),
		expectedDelivery: e.object({
			on: e.iso.date().register(e.globalRegistry, { description: "The expected delivery date. Must be later than today." }),
			timeslot: e.object({
				from: e.string().register(e.globalRegistry, { description: "The start time of the expected delivery. Must be before `to`." }),
				to: e.string().register(e.globalRegistry, { description: "The end time of the expected delivery. Must be after `from`." })
			}).register(e.globalRegistry, { description: "The timeslot of the expected delivery." })
		}).register(e.globalRegistry, { description: "The expected delivery of the purchase order." }).optional()
	}).register(e.globalRegistry, { description: "Body for creating a purchase order." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var ke = Y;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		aggregation: e.tuple([xe]).register(e.globalRegistry, { description: "Fields to summarize data for based on the filters and query." }).optional(),
		filter: e.object({
			fulfilmentPlatform: e.array(q).optional(),
			purchaseOrderId: e.array(e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." })).optional(),
			status: e.array(Se).optional()
		}).optional(),
		limit: e.int().gte(1).lte(50).register(e.globalRegistry, { description: "The maximum number of purchase orders to retrieve." }).optional().default(50),
		pageToken: e.string().register(e.globalRegistry, { description: "The page token to retrieve the next page of purchase orders." }).optional(),
		query: e.string().register(e.globalRegistry, { description: "The following operators are supported:\n'+ signifies AND operation'\n'| signifies OR operation'\n'- negates a single token'\n'\" wraps a number of tokens to signify a phrase for searching'\n'* at the end of a term signifies a prefix query'\n'( and ) signify precedence'\n'~N after a word signifies edit distance (fuzziness)'\n'~N after a phrase signifies slop amount'\nTo use one of these characters literally, escape it with a preceding backslash (\\)." }).optional(),
		sort: e.object({
			createdAt: J.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the `createdAt` property." })).optional(),
			deliveryQuantity: J.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the `deliveryType.quantity` property." })).optional(),
			deliverySupplierReference: J.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the `deliverySupplierDetails.reference` property." })).optional(),
			deliveryType: J.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the `deliveryType.type` property." })).optional(),
			expectedDelivery: J.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the `expectedDelivery.on` property." })).optional(),
			externalReference: J.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the `externalReference` property." })).optional(),
			status: J.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the `status` property." })).optional()
		}).register(e.globalRegistry, { description: "When no `query` is provided the default sort is by `createdAt` descending. When a `query` is provided the default sort is by relevance." }).optional()
	}).optional()
});
var Ae = e.object({
	results: e.array(Ee).register(e.globalRegistry, { description: "The list of purchase orders." }),
	total: e.object({
		relation: e.union([e.enum(["eq", "gte"]), e.string()]).register(e.globalRegistry, { description: "The relation of the total number of purchase orders." }),
		value: e.int().gte(0).register(e.globalRegistry, { description: "The total number of purchase orders." })
	}),
	aggregations: e.object({ status: e.array(e.object({
		key: e.union([e.enum([
			"CANCELED",
			"COMPLETED",
			"CONCEPT",
			"PARTIALLY_RECEIVED",
			"REGISTERED",
			"REGISTRATION_REQUESTED"
		]), e.string()]).register(e.globalRegistry, { description: "The status of the purchase order." }),
		count: e.int().gte(0)
	})).optional() }).register(e.globalRegistry, { description: "The requested aggregations of the purchase orders." }).optional(),
	nextPageToken: e.string().register(e.globalRegistry, { description: "The next page token to retrieve the next page of purchase orders." }).optional()
}).register(e.globalRegistry, { description: "The listed purchase orders." });
e.object({
	body: e.never().optional(),
	path: e.object({ purchaseOrderId: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }) }),
	query: e.object({
		firstName: e.string().register(e.globalRegistry, { description: "First name on the packing slip." }).optional(),
		lastName: e.string().register(e.globalRegistry, { description: "Last name on the packing slip." }).optional()
	}).optional(),
	headers: e.object({ Accept: e.union([e.enum(["application/pdf"]), e.string()]) })
});
var je = e.string().register(e.globalRegistry, { description: "The packing slip PDF." });
e.object({
	body: e.object({ ids: e.array(e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." })) }).register(e.globalRegistry, { description: "Body for removing a purchase order ." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Me = e.void().register(e.globalRegistry, { description: "Purchase order is removed." });
e.object({
	body: e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
		productIds: e.array(e.uuid().register(e.globalRegistry, { description: "The ID of the product." })).register(e.globalRegistry, { description: "The product IDs to remove from the purchase order." })
	}).register(e.globalRegistry, { description: "Body for removing lines of a purchase order." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Ne = e.union([
	e.object({ status: e.literal("CONCEPT") }).and(Y),
	e.object({ status: e.literal("REGISTERED") }).and(X),
	e.object({ status: e.literal("REGISTRATION_REQUESTED") }).and(Z)
]);
e.object({
	body: e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
		supplier: e.string().register(e.globalRegistry, { description: "The name of the supplier." }),
		reference: e.string().register(e.globalRegistry, { description: "The reference of the supplier." }).optional()
	}).register(e.globalRegistry, { description: "Body for setting the delivery supplier details for a purchase order." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Pe = e.union([
	e.object({ status: e.literal("CONCEPT") }).and(Y),
	e.object({ status: e.literal("REGISTERED") }).and(X),
	e.object({ status: e.literal("REGISTRATION_REQUESTED") }).and(Z)
]);
e.object({
	body: e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
		type: e.union([e.enum([
			"CONTAINER",
			"PACKAGE",
			"PALLET"
		]), e.string()]).register(e.globalRegistry, { description: "The type of the expected delivery." }),
		quantity: e.int().gte(1).lte(100).register(e.globalRegistry, { description: "The quantity of the expected delivery type." })
	}).register(e.globalRegistry, { description: "Body for setting the delivery type of a purchase order." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Fe = e.union([
	e.object({ status: e.literal("CONCEPT") }).and(Y),
	e.object({ status: e.literal("REGISTERED") }).and(X),
	e.object({ status: e.literal("REGISTRATION_REQUESTED") }).and(Z)
]);
e.object({
	body: e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
		on: e.iso.date().register(e.globalRegistry, { description: "The expected delivery date. Must be later than today." }),
		timeslot: e.object({
			from: e.string().register(e.globalRegistry, { description: "The start time of the expected delivery. Must be before `to`." }),
			to: e.string().register(e.globalRegistry, { description: "The end time of the expected delivery. Must be after `from`." })
		}).register(e.globalRegistry, { description: "The timeslot of the expected delivery." })
	}).register(e.globalRegistry, { description: "Body for setting the expected delivery of a purchase order." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Ie = e.union([
	e.object({ status: e.literal("CONCEPT") }).and(Y),
	e.object({ status: e.literal("REGISTERED") }).and(X),
	e.object({ status: e.literal("REGISTRATION_REQUESTED") }).and(Z)
]);
e.object({
	body: e.object({ ids: e.array(e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." })) }).register(e.globalRegistry, { description: "Body for registering purchase orders." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Le = e.void().register(e.globalRegistry, { description: "Purchase orders are requested to register." });
e.object({
	body: e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The ID of the purchase order." }),
		productId: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
		quantity: e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "The quantity of the product." })
	}).register(e.globalRegistry, { description: "Body for updating the quantity of a purchase order line." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Re = e.union([
	e.object({ status: e.literal("CONCEPT") }).and(Y),
	e.object({ status: e.literal("REGISTERED") }).and(X),
	e.object({ status: e.literal("REGISTRATION_REQUESTED") }).and(Z)
]), ze = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await F.parseAsync(e),
	responseValidator: async (e) => await De.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/add-lines",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Be = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await I.parseAsync(e),
	responseValidator: async (e) => await Oe.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/cancel",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ve = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await L.parseAsync(e),
	responseValidator: async (e) => await ke.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/create",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), He = (e) => (e?.client ?? S).get({
	requestValidator: async (e) => await R.parseAsync(e),
	responseValidator: async (e) => await Ae.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/purchase-orders",
	...e
}), $ = (e) => (e.client ?? S).get({
	requestValidator: async (e) => await z.parseAsync(e),
	responseValidator: async (e) => await je.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/purchase-orders/{purchaseOrderId}/packing-slip",
	...e
}), Ue = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await B.parseAsync(e),
	responseValidator: async (e) => await Me.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/remove",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), We = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await V.parseAsync(e),
	responseValidator: async (e) => await Ne.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/remove-lines",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ge = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await H.parseAsync(e),
	responseValidator: async (e) => await Pe.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/set-delivery-supplier-details",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ke = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await U.parseAsync(e),
	responseValidator: async (e) => await Fe.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/set-delivery-type",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), qe = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await W.parseAsync(e),
	responseValidator: async (e) => await Ie.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/set-expected-delivery",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Je = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await G.parseAsync(e),
	responseValidator: async (e) => await Le.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/register",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ye = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await K.parseAsync(e),
	responseValidator: async (e) => await Re.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/update-line-quantity",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
});
//#endregion
export { t as $, B as A, K as B, le as C, de as D, L as E, ge as F, N as G, P as H, U as I, j as J, w as K, _e as L, he as M, me as N, G as O, H as P, n as Q, W as R, F as S, ue as T, se as U, be as V, ce as W, T as X, M as Y, S as Z, z as _, Ve as a, fe as b, We as c, qe as d, Ye as f, C as g, k as h, Be as i, V as j, ye as k, Ge as l, O as m, $ as n, Je as o, D as p, E as q, ze as r, Ue as s, He as t, Ke as u, pe as v, I as w, A as x, R as y, ve as z };
